module.exports = {"title":"Photos","subtitle":"Attempting to portray my life as more interesting than it actually is\n","icon":"camera","body":""}


//////////////////
// WEBPACK FOOTER
// ./photos.md
// module id = 784
// module chunks = 0